import { Grid, Stack } from '@mui/material'
import React, { isValidElement } from 'react'
import PropTypes from 'prop-types'
import { map, isObject } from 'lodash'

const PopoverContent = ({ explaination, legend }) => {
    return (
        <Grid container size={12} spacing={1.5} paddingBottom={1.5}>
            {!!explaination && <Grid>{explaination}</Grid>}
            <Stack spacing={1}>
                {map(legend?.keys, (value, key) => (
                    <Grid container key={key} spacing={0.5}>
                        {
                            isObject(value) && !isValidElement(value) ?
                                <Grid sx={{ fontWeight: 'bold', color: value.color }}>{value.label}</Grid>
                                :
                                <Grid sx={{ fontWeight: 'bold' }}>{value}</Grid>
                        }
                        <Grid size={12}>{legend?.label?.[key]}</Grid>
                    </Grid>
                ))}
            </Stack>
        </Grid>
    )
}

PopoverContent.propTypes = {
    explaination: PropTypes.string,
    legend: PropTypes.shape({
        keys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.shape({})])),
        label: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    }),
}

export default PopoverContent